module.exports = __webpack_public_path__ + "img/image_6.8fc131f1.png";